module.exports = __webpack_public_path__ + "static/media/folder2.76d071b4.svg";